






















import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import _ from 'lodash'
import moment from 'moment'
import { ChartTPData } from '@/model/dashboard/ChartTPData'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
  minYear: number
  maxYear: number
  selectedYear: number
  chartData: any | null
  monthsList: any[]
  selectedMonth: string
}

export default Vue.extend({
  name: 'PieChartTP',

  props: {
    pieChartTPLabel: String,
    pieChartTPData: {
      type: Array as () => Array<ChartTPData>
    }
  },

  data (): ComponentData {
    return {
      chart: undefined,
      minYear: parseInt(moment().format('YYYY')),
      maxYear: parseInt(moment().format('YYYY')),
      selectedYear: parseInt(moment().format('YYYY')),
      chartData: null,
      monthsList: [],
      selectedMonth: '0'
    }
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },
  },

  methods: {
    onBeforeClick (): void {
      this.selectedYear = this.selectedYear - 1
      this.createChart()
    },

    onNextClick (): void {
      this.selectedYear = this.selectedYear + 1
      this.createChart()
    },

    onMonthChange (): void {
      this.createChart()
    },

    createChart (): any {
      //@ts-ignore
      let chart = am4core.create(this.$refs.pieChart, am4charts.PieChart)

      if(this.chartData[this.selectedYear]) {
        let data = this.chartData[this.selectedYear]
        if(this.selectedMonth !== '0') {
          data = data.filter((item: any) => item.month === this.selectedMonth)
        }

        const grouped = _.groupBy(data, 'name')
        chart.data = _.map(grouped, (items, name) => ({
          name,
          value: _.sumBy(items, (item) => parseInt(item.sum)),
        }))
      }

      // Add and configure Series
      let pieSeries = chart.series.push(new am4charts.PieSeries())
      pieSeries.dataFields.value = 'value'
      pieSeries.dataFields.category = 'name'

      // Let's cut a hole in our Pie chart the size of 40% the radius
      chart.innerRadius = am4core.percent(40)

      // Disable ticks and labels
      pieSeries.labels.template.disabled = true
      pieSeries.ticks.template.disabled = true
      pieSeries.alignLabels = false
      am4core.percent(-40)
      pieSeries.slices.template.fillOpacity = 1

      let hs = pieSeries.slices.template.states.getKey('hover')
      hs.properties.scale = 1
      hs.properties.fillOpacity = 0.5

      // Add a legend
      chart.legend = new am4charts.Legend();
      chart.legend.scrollable = true;
      //@ts-ignore
      let legendContainer = am4core.create(this.$refs.legend, am4core.Container);
      legendContainer.layout = "vertical";
      legendContainer.width = am4core.percent(100);
      legendContainer.height = am4core.percent(100);
      chart.legend.parent = legendContainer;


      //chart.legend = new am4charts.Legend()
      //chart.legend.position = "right"

      /*pieSeries.colors.list = [
        am4core.color('#0b7dda'),
        am4core.color('#03b237'),
      ]*/

      this.chart = chart
    }
  },

  mounted () {
    this.chartData = _.groupBy(this.pieChartTPData, 'year')

    const years = Object.keys(this.chartData).map(Number)
    this.minYear = Math.min(...years)
    this.createChart()
    moment.locale(this.selectedLocale)
    const months = moment.months()
    this.monthsList = months.map((item: string, index: number) => {
      return { month: (index + 1).toString(), label: item }
    })

    this.monthsList.unshift({ month: '0', label: 'Ganzes Jahr' })
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }

})
